<template>
  <div class="rz-pagination">
    <!--<span v-if="!simply" class="demonstration">当前显示 {{start}} 到 {{end}}条，共 {{total}} 条记录</span>-->
    <span class="demonstration">共 {{ total }} 条，每页显示 {{ pageSize }} 条</span>
    <el-pagination
      background
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeList"
      :layout="layout"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 20,
    },
    simply: {
      type: Boolean,
      default: true,
    },
    pageSizeList: {
      type: Array,
      default: [5, 10, 20, 50, 100, 200, 500],
    },
    popperClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      start: (this.page - 1) * this.pageSize + 1,
      end: (this.page - 1) * this.pageSize + this.pageSize,
      layout: '->,sizes, prev, pager, next, jumper',
    }
  },
  watch: {
    page(to) {
      this.start = (to - 1) * this.pageSize + 1
      this.end =
        (to - 1) * this.pageSize + this.pageSize > this.total ? this.total : (to - 1) * this.pageSize + this.pageSize
    },
    total(to) {
      if (this.end > this.total) {
        this.end = this.total
      }
      if (this.total <= 20) {
        this.end = this.total
      } else if (this.start < 20) {
        this.end = 20
      }
    },
    pageSize(to) {
      this.start = (this.page - 1) * to + 1
      this.end = (this.page - 1) * to + to > this.total ? this.total : (this.page - 1) * to + to
    },
  },
  beforeMount() {
    if (!this.simply) {
      this.layout = ' ->,prev, pager, next, jumper'
    }
  },
  mounted() {
    let curUrlPageSize = Number(localStorage.getItem('curUrlPageSize'))
    let curUrlPageIndex = Number(localStorage.getItem('curUrlPageIndex'))
    if (curUrlPageIndex || curUrlPageSize) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.canSavePage = 0
          this.handleCurrentChange(curUrlPageIndex || 1)
          this.$nextTick(() => {
            this.$refs.page.internalCurrentPage = curUrlPageIndex || 1 // 强制更新，解决页码不自动更新的问题
          })
        }, 500);
      })
    }
  },
  methods: {
    handleCurrentChange(val) {
      localStorage.setItem('curUrlPageIndex', val)
      let curUrlPageSize = Number(localStorage.getItem('curUrlPageSize')) || this.pageSize
      this.$emit('current-change', val, curUrlPageSize)
    },
    // 翻页
    handleSizeChange(val) {
      localStorage.removeItem('curUrlPageIndex')
      localStorage.setItem('curUrlPageSize', val)
      this.$emit('current-change', 1, val)
    },
  },
}
</script>
<style lang='less'>
.el-pagination {
  height: 24px;
  padding: 0;
  button {
    &:hover {
      color: @theme-color;
    }
  }
  .el-pager li {
    height: 24px;
    line-height: 22px;
  }
  .btn-prev,
  .btn-next {
    margin-left: 10px;
    border: 1px solid @border-line-color;
    border-radius: 3px;
    height: 24px;
    min-width: 24px;
    background-color: @theme-bg-color;
    color: @font-color-gray;
    padding: 5px;
  }
  .btn-prev {
    margin-right: 10px;
  }
  .number {
    height: 24px;
    background-color: transparent;
    color: @font-color-base;
    font-size: @font-tiny;
    font-weight: 500;
    min-width: 24px;
    line-height: 22px;
    &:hover {
      color: @font-color-theme;
    }
  }
  .number.active {
    background-color: @theme-color;
    color: @font-color-white;
    border: 1px solid @border-line-color;
    border-radius: 3px;
  }
  .el-pagination__jump {
    height: 24px !important;
    line-height: 24px !important;
    color: @font-color-base;
    font-size: @font-tiny !important;
    .el-pagination__editor.el-input {
      width: 34px;
      height: 24px;
      .el-input__inner {
        height: 24px !important;
        border-radius: 3px;
        background-color: @base-color;
      }
    }
  }
  .el-pagination__sizes {
    .el-input__inner {
      height: 26px !important;
      line-height: 26px !important;
      font-size: @font-tiny;
    }
  }
  .el-pager li {
    background: @base-color;
    color: @font-color-default;
  }
}
.demonstration {
  vertical-align: middle;
  line-height: 24px;
  font-size: @font-tiny;
  color: @font-color-base;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.demonstration + .el-pagination {
  float: right;
  text-align: right;
}
</style>

<style scoped lang="less">
.rz-pagination {
  padding: 10px 15px;
  /deep/ .el-pagination__rightwrapper {
    display: flex;
    align-items: center;
  }
}
</style>
